import { render } from "./ThemeConfigs.vue?vue&type=template&id=fc90b2a0&scoped=true"
import script from "./ThemeConfigs.vue?vue&type=script&lang=js"
export * from "./ThemeConfigs.vue?vue&type=script&lang=js"

import "./ThemeConfigs.vue?vue&type=style&index=0&id=fc90b2a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc90b2a0"]])

export default __exports__